import * as React from "react";
import { LinkContainer, DocumentTitle, PageHeader } from "components/common";
import { Button } from "components/bootstrap";
import UsersPageNavigation from "components/users/navigation/UsersPageNavigation";
import SecurityRoutes from "security/Routes";
import TeamCreate from "../components/team-create/TeamCreate";
const TeamCreatePage = () => /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Team Create" }, /* @__PURE__ */ React.createElement(UsersPageNavigation, null), /* @__PURE__ */ React.createElement(
  PageHeader,
  {
    title: "Team Create",
    actions: /* @__PURE__ */ React.createElement(LinkContainer, { to: SecurityRoutes.TEAMS.CREATE }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, "Create Team"))
  },
  /* @__PURE__ */ React.createElement("span", null, "Create new team and assign users."),
  /* @__PURE__ */ React.createElement("span", null)
), /* @__PURE__ */ React.createElement(TeamCreate, null));
export default TeamCreatePage;
